// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6276":"css/app.6677","7381":"css/admin-app.6677"}[chunkId] + ".css";
};